import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import { Logo } from './Logo';

const Footer = () => {
  const scrollToSection = (sectionId: string) => {
    if (sectionId === 'top') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, sectionId: string) => {
    // If we're on the home page, just scroll
    if (window.location.pathname === '/') {
      e.preventDefault();
      scrollToSection(sectionId);
    }
    // Otherwise, let the link navigate to home with hash
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="space-y-4">
            <div className="flex items-center gap-0.5">
              <Logo size={32} />
              <span className="text-xl font-semibold">BeyondPages</span>
            </div>
            <p className="text-gray-400">
              Wir machen Bücher lebendig durch digitale Innovation.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Navigation</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="/" 
                  onClick={(e) => handleNavClick(e, 'top')}
                  className="text-gray-400 hover:text-white"
                >
                  Home
                </a>
              </li>
              <li>
                <a 
                  href="/#features" 
                  onClick={(e) => handleNavClick(e, 'features')}
                  className="text-gray-400 hover:text-white"
                >
                  Leistungen
                </a>
              </li>
              <li>
                <a 
                  href="/#pricing" 
                  onClick={(e) => handleNavClick(e, 'pricing')}
                  className="text-gray-400 hover:text-white"
                >
                  Preise
                </a>
              </li>
              <li>
                <a 
                  href="/#demos" 
                  onClick={(e) => handleNavClick(e, 'demos')}
                  className="text-gray-400 hover:text-white"
                >
                  Demos
                </a>
              </li>
              <li>
                <a 
                  href="/#faq" 
                  onClick={(e) => handleNavClick(e, 'faq')}
                  className="text-gray-400 hover:text-white"
                >
                  FAQ
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Kontakt</h3>
            <ul className="space-y-2">
              <li className="flex items-center">
                <Mail className="h-5 w-5 mr-2 text-[#FF9900]" />
                <a href="mailto:info@beyondpages.io" className="text-gray-400 hover:text-white">
                  info@beyondpages.io
                </a>
              </li>
              <li className="flex items-center">
                <MapPin className="h-5 w-5 mr-2 text-[#FF9900]" />
                <span className="text-gray-400">
                  Glasstr. 84<br />
                  50823 Köln Ehrenfeld
                </span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4">Rechtliches</h3>
            <ul className="space-y-2">
              <li><Link to="/impressum" className="text-gray-400 hover:text-white">Impressum</Link></li>
              <li><Link to="/privacy" className="text-gray-400 hover:text-white">Datenschutz</Link></li>
              <li><Link to="/terms" className="text-gray-400 hover:text-white">Nutzungsbedingungen</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} BeyondPages</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;